import { useEffect, useState } from 'react';

// UI
import { Grid, Stack, Typography, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Toggle from 'react-toggle';

// Services
import { getTypeDocuments } from 'services/contracts';
import PropTypes from 'prop-types';

const StaffDocuments = ({ documents, setDocuments, loading }) => {
    const [documentGroups, setDocumentGroups] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);

    const [groupSelected, setGroupSelected] = useState('');

    const getGroupsDocuments = () => {
        setDocumentGroups([
            { id: 3, nome: 'Departamento Pessoal' },
            { id: 4, nome: 'Mensal' },
            { id: 5, nome: 'Saúde' },
            { id: 7, nome: 'Segurança' }
        ]);
    };

    const getTypesDocuments = () => {
        getTypeDocuments().then((resp) => {
            setDocumentTypes(resp.data);
        });
    };

    useEffect(() => {
        if (!groupSelected && documentGroups.length) setGroupSelected(documentGroups[0]);
    }, [documents]); // eslint-disable-line

    useEffect(() => {
        getGroupsDocuments();
        getTypesDocuments();
    }, []);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <InputLabel id="document-group-select" shrink>
                            Grupo de Documentos
                        </InputLabel>
                        <Select
                            labelId="document-group-select"
                            id="document-group-select"
                            value={groupSelected}
                            label="Grupo de Documentos"
                            onChange={(e) => setGroupSelected(e.target.value)}
                        >
                            {documentGroups.map((item) => (
                                <MenuItem key={item.id} value={item}>
                                    {item.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    {documentTypes
                        .filter((type) => type.grupo_documento_id == groupSelected?.id)
                        .map((type) => (
                            <Stack
                                key={type.id}
                                direction="row"
                                alignItems="center"
                                spacing={2}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    py: 4,
                                    px: 2,
                                    mb: 1,
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '0.5rem'
                                }}
                            >
                                <Toggle
                                    checked={documents?.find((doc) => doc === type.id) !== undefined}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setDocuments([...documents, type.id]);
                                        } else {
                                            setDocuments(documents?.filter((doc) => doc !== type.id));
                                        }
                                    }}
                                    disabled={loading}
                                />
                                <Typography variant="subtitle1">
                                    {type.nome}
                                    {type.especificacoes && ` (${type.especificacoes})`}
                                </Typography>
                            </Stack>
                        ))}
                </Grid>
            </Grid>
        </>
    );
};

StaffDocuments.propTypes = {
    documents: PropTypes.array,
    setDocuments: PropTypes.func,
    loading: PropTypes.bool
};

export default StaffDocuments;
